'use client';

import { FC } from 'react';
import { ButtonBase, UserAccessWithRoleCheck } from '../../../common';
import { submitButtonWrapperAndButtonProperStyles } from '../../utils';
import { getAppConfig } from '@bts-web/core-app-config';

export const TradeFormSubmitButton: FC<{
  disabled?: boolean;
  submitText: string;
  loading: boolean;
}> = ({ disabled, submitText, loading }) => {
  const { appId } = getAppConfig();

  return (
    <div className={submitButtonWrapperAndButtonProperStyles}>
      <UserAccessWithRoleCheck>
        <ButtonBase
          type="submit"
          visual={appId === 4 ? 'accent' : 'primary'}
          size="large"
          data-testid="trade-submit-button"
          aria-label="submit trade button"
          disabled={loading || disabled}
          isLoading={loading}
          fullWidth
        >
          <span>{submitText}</span>
        </ButtonBase>
      </UserAccessWithRoleCheck>
    </div>
  );
};
